module.exports = __webpack_public_path__ + "static/img/banner_home04.45a59d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner/banner_home04.jpg
// module id = YLr9
// module chunks = 15